import React,{useState,useEffect} from "react";
import { Link } from "react-router-dom";
import {getStudentIdData } from "../../../lib/studentcollegelist"
import {addData, deleteIdData} from "../../../lib/studentcollegelist"
import {getAllData } from "../../../lib/collegerank"
import {useAuth} from "../../../usercontext";

export default function GlobalCollegeList({slug,isStudent}) {
    const [collegelist, setCollegeList] = useState([]);
    const [studentCollegeList, setStudentCollegeList] = useState([]);
    const { profile } = useAuth();
    //const slug = "6cd022a6-81d9-4aba-8487-fd34f1ffd4c9";
    //const slug = profile.id;
    //const cls =  profile.class;


    function getStudentData(colid) {

      if (studentCollegeList.length > 0) {
        //console.log("studentLessonList", studentLessonList);
        const result = studentCollegeList.filter(item => item.collegeId === colid);
  
        //console.log("result", result);
        return result.length > 0 ? result[0].id : 0;
      }
      else
        return 0;
    }

    function getStudentCollege(colid) {

      if (studentCollegeList.length > 0) {
        //console.log("studentLessonList", studentLessonList);
        const result = studentCollegeList.filter(item => item.collegeId === colid);
  
        //console.log("result", result);
        let returnresult =  false;
  
        if (result.length > 0 )
          returnresult =  result[0].isCheck;
  
          return returnresult;
  
       // return result.length > 0 ? true : 0;
      }
      else
        return false;
    }


    async function UpdateisCheck(Id,isCheck,collegeId) {


      //Id doesnt exist you have to add
      if(Id == 0)  
      {
        console.log("Add",Id,isCheck,collegeId);
        await addData({
          isCheck : !isCheck,
          studentId : slug,
          collegeId : collegeId
        });

      }
      else
      {
        console.log("Update",Id,isCheck,collegeId);
        await deleteIdData(Id);
        /*
        await updateData({
          id: parseInt(Id),
          isCheck : !isCheck
        });
*/
      }
      GetData();
      }


function ChangeStatus(Id, isCheck,collegeId) {

    UpdateisCheck(Id, isCheck,collegeId);
}

    async function GetData() {
        const colleges = await getAllData(slug);
        setCollegeList(colleges);


        const studentdata = await getStudentIdData(slug);
        setStudentCollegeList(studentdata);
        console.log("studentdata",studentdata);
      }
    
    useEffect(() => {
      GetData();
    }, [profile]);

    return (
                <div className="col-12">
                  <div className="settings-widget profile-details">
                    <div className="settings-inner-blk p-0">
                      <div className="profile-heading">
                        <h3>College List</h3>
                      </div>
                      <div className="comman-space pb-0">
                        <div className="settings-invoice-blk table-responsive">
                          {/* Invoice info */}
                          <table className="table table-hover">
                            <thead>
                              <tr>
                                <th>Id</th>
                                <th>College</th>
                                <th>Is Check</th>
                              </tr>
                            </thead>
                            <tbody>
                            {collegelist.map(function (data) {
                              return (
                                <tr key={data.id}>
                                <td>
                                  <Link
                                    to="#"
                                    className="invoice-no"
                                  >
                                  {data.id}
                                  </Link>
                                </td>
                                <td>{data.collegename}</td>
                                <td><div className="form-check form-switch check-on">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                checked={getStudentCollege(data.id)}
                                onChange={(e) => ChangeStatus(getStudentData(data.id),getStudentCollege(data.id),data.id)}
                              />
                            </div></td>

                              </tr>
                              )
                            })}
                            </tbody>
                          </table>
                          {/* Invoice info */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
      );
}
